import React, {useEffect} from "react";

import {spacing16} from "@churchofjesuschrist/eden-style-constants";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import vanityUrlService from "./vanity-url-service";
import stringHasValue from "../../../utils/string-has-value";
import useTranslation from "../../../utils/use-translations";
import CenteredCard from "../../generic/centered-card/centered-card";
import ContentCard from "../../generic/content-card/content-card";
import useStatus from "../../generic/hooks/use-status/use-status";
import LoadingSpinner from "../../generic/loading-spinner/loading-spinner";
import usePageStandardFunctionality from "../use-page-standard-functionality";

const LoadingHolder = styled.div`
margin:${spacing16};
`

const stringGroups = [
  {
    name:"shared",
    keys:[
      "pageNotFound",
      "pageNotFoundMessage",
      "home"
    ]
  }
];
const service = vanityUrlService();
const pageGroups = ["shared"];

const NotFoundPage = () => {
  const navigate = useNavigate();
  usePageStandardFunctionality({
    stringGroups: pageGroups,
  });
  const {status, setSavingStatus: loading, setResetStatus:done} = useStatus();

  useEffect(() => {
    const load = async(pattern, others = []) => {
      try {
        loading();
        const data = await service.search(pattern);
        done();
        const pgmId = parseInt(data?.programId);
        const hubId = parseInt(data?.hubId);
        if (!isNaN(pgmId) || !isNaN(hubId)) {
          const otherParts = others.filter(s => stringHasValue(s));
          const otherUrl = otherParts.join("/");
          if (!isNaN(pgmId)) {
            navigate(`/institute/${pgmId}/${otherUrl}`);
          } else {
            navigate(`/hub/${hubId}/${otherUrl}`);
          }
        }
      } catch (e) {
        done();
      }

    }
    const [,search,...others] = window.location.pathname.split("/");
    if (stringHasValue(search)) {
      load(search,others)
    }
  },[done, loading, navigate])

  const {managedStrings} = useTranslation(stringGroups);


  return ( status.saving ? <LoadingHolder><LoadingSpinner/></LoadingHolder> : (
    <CenteredCard><ContentCard title={managedStrings.pageNotFound}
      body={managedStrings.pageNotFoundMessage}
      callToActionRoute="/"
      image={{
        id: "babfc196740846daacbcf5521ebe05b3ab5f2f6d",
        target: 310,
        mobileTarget: 200,
        dimension: "height"
      }}
      callToActionText={managedStrings.home}/>
    </CenteredCard>));
}

export default NotFoundPage;